// Data Center module page-level translations
export default {
  // ─── Dataset common ────────────────────────────────────────────────────────
  'data.dataset.status.enabled': 'Active',
  'data.dataset.status.disabled': 'Disabled',
  'data.dataset.status.enable': 'Enable',
  'data.dataset.status.disable': 'Disable',
  'data.dataset.status.notEnabled': 'Not Enabled',
  'data.dataset.status.alreadyEnabled': 'Enabled',

  // ─── Feedback messages ─────────────────────────────────────────────────────
  'data.dataset.message.opSuccess': 'Operation successful',
  'data.dataset.message.opFail': 'Operation failed',
  'data.dataset.message.fetchListFail': 'Failed to fetch knowledge base list',
  'data.dataset.message.fetchDetailFail': 'Failed to fetch knowledge base detail',
  'data.dataset.message.createSuccess': 'Created successfully',
  'data.dataset.message.createFail': 'Creation failed',
  'data.dataset.message.addFail': 'Add failed, please retry!',
  'data.dataset.message.updateSuccess': 'Updated successfully',
  'data.dataset.message.updateFail': 'Update failed',
  'data.dataset.message.deleteSuccess': 'Deleted successfully',

  // ─── List page ─────────────────────────────────────────────────────────────
  'data.dataset.list.title': 'Knowledge Base Management',
  'data.dataset.list.new': 'New',
  'data.dataset.list.col.cover': 'Cover',
  'data.dataset.list.col.name': 'Name',
  'data.dataset.personalName': 'Personal Knowledge Base',
  'data.dataset.list.col.desc': 'Description',
  'data.dataset.list.col.model': 'Embedding Model',
  'data.dataset.list.col.docCount': 'Doc Count',
  'data.dataset.list.col.role': 'Role',
  'data.dataset.list.col.company': 'Company',
  'data.dataset.list.col.updateTime': 'Updated At',
  'data.dataset.list.col.action': 'Action',
  'data.dataset.list.action.edit': 'Edit',
  'data.dataset.list.action.config': 'Config',
  'data.dataset.list.action.view': 'View',
  'data.dataset.list.action.delete': 'Delete',
  'data.dataset.delete.confirm.title': 'Delete this knowledge base?',
  'data.dataset.delete.confirm.content': 'Delete knowledge base "{name}"? After soft deletion the data is recoverable by the backend and the base will no longer appear in the list.',
  'data.dataset.delete.confirm.ok': 'Delete',
  'data.dataset.delete.confirm.cancel': 'Cancel',
  'data.dataset.list.tag.more': 'More',
  'data.dataset.list.tag.collapse': 'Collapse',
  'data.dataset.list.total': 'Total',

  // ─── Search form ───────────────────────────────────────────────────────────
  'data.dataset.search.name.label': 'Name',
  'data.dataset.search.name.placeholder': 'Enter knowledge base name',
  'data.dataset.search.company.label': 'Company',
  'data.dataset.search.company.placeholder': 'Select company',
  'data.dataset.search.role.label': 'Role',
  'data.dataset.search.role.placeholder': 'Select role',
  'data.dataset.search.status.label': 'Status',
  'data.dataset.search.status.placeholder': 'Select status',

  // ─── Card component ────────────────────────────────────────────────────────
  'data.dataset.card.docCount': 'Docs:',

  // ─── Create / Edit form ────────────────────────────────────────────────────
  'data.dataset.create.title': 'Create Knowledge Base',
  'data.dataset.create.subtitle': 'Fields marked with * are required',
  'data.dataset.edit.title': 'Edit Knowledge Base',
  'data.dataset.section.basic': 'Basic Info',
  'data.dataset.section.config': 'Configuration',
  'data.dataset.section.permission': 'Permissions',

  'data.dataset.form.name.label': 'Name',
  'data.dataset.form.name.placeholder': 'Enter knowledge base name',
  'data.dataset.form.name.required': 'Please enter knowledge base name',
  'data.dataset.form.cover.label': 'Cover',
  'data.dataset.form.icon.label': 'App Icon',
  'data.dataset.form.desc.label': 'Description',
  'data.dataset.form.desc.placeholder': 'Enter knowledge base description',
  'data.dataset.form.sort.label': 'Sort',
  'data.dataset.form.sort.placeholder': 'Enter sort number',
  'data.dataset.form.sort.required': 'Please enter sort number',
  'data.dataset.form.status.label': 'Status',
  'data.dataset.form.status.placeholder': 'Select status',
  'data.dataset.form.status.required': 'Please select status',
  'data.dataset.form.file-company.label': 'File points to company',
  'data.dataset.form.file-company.placeholder': 'Please select a file that points to the company',
  'data.dataset.form.company.label': 'Company',
  'data.dataset.form.company.placeholder': 'Select company',
  'data.dataset.form.dept.label': 'Department',
  'data.dataset.form.dept.placeholder': 'Select department',
  'data.dataset.form.dept.keyword.placeholder': 'Enter keyword',
  'data.dataset.form.dept.other': 'Other',
  'data.dataset.form.role.label': 'Role',
  'data.dataset.form.role.placeholder': 'Select role',
  'data.dataset.form.user.label': 'User',
  'data.dataset.form.user.placeholder': 'Select user',
};
